var _effectorFileName = "/builds/gmini/front-common/src/components/SwitchProject/ProjectBadge/ProjectBadge.tsx";
import "core-js/modules/es.array.slice.js";
import { Skeleton } from '@mui/material';
import { Tooltip } from '@gmini/ui-kit';
import { Wrapper, Text } from "./ProjectBadge.styled";
import { Folder } from "./FolderIcon.styled";
import { maxLengthProjectName } from "./contants";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProjectBadge = function ProjectBadge(_ref) {
  var projectName = _ref.projectName,
      loading = _ref.loading,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? /*#__PURE__*/_jsx(Folder, {}) : _ref$icon;
  var isMoreThanMax = projectName.length >= maxLengthProjectName;
  var shortProjectName = isMoreThanMax ? "".concat(projectName.slice(0, maxLengthProjectName), "...") : projectName;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [icon, /*#__PURE__*/_jsx(Text, {
      children: loading ? /*#__PURE__*/_jsx(Skeleton, {
        width: "100px"
      }) : /*#__PURE__*/_jsx(Tooltip, {
        noMaxWidth: true,
        title: isMoreThanMax ? projectName : '',
        placement: "bottom",
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: shortProjectName
        })
      })
    })]
  });
};